import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  body {
    background-color: var(--color-base-background);
    font-family: 'Inter', sans-serif;
    overflow: hidden;
  }
`
